export { default } from "../.internal/themes/material";



// WEBPACK FOOTER //
// ../../../src/themes/material.ts